<div class="contact-container" *ngIf="baseSite$ | async as baseSite">
  <div class="content">
    <div class="headline" *ngIf="component.title">
      <kion-headline-tag
        [title]="component.title"
        [titleSize]="component.titleSize"
      ></kion-headline-tag>
    </div>
    <div class="hotline">
      {{ 'footer.hotline' | translate: { phoneNumber: baseSite.phoneNumber } }}
    </div>
    <div class="opening">
      {{ baseSite.openingHours }}
    </div>
    <div class="links" *ngFor="let link of lazyComponents$ | async">
      <kion-link
        [linkRef]="link"
      ></kion-link>
    </div>
  </div>
</div>
